import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useStore } from '…/app/state/useStore.mts';

import { WorkspacesList } from './components/WorkspacesList.tsx';
import { Dock } from './components/Dock.tsx';
import { AddWorkspaceCard } from './components/WorkspaceSearch.tsx';
import type { Workspace, WorkspaceId } from '../state/states.js';
import { CreateWorkspaceDialog } from './components/CreateWorkspaceDialog.tsx';

export function WorkspacesListPage() {
  const {
    adminRoles,
    csxRole,
    profile,
  } = useStore((data) => data.user);
  const workspaces = useStore((data) => data.workspaces);
  const navigate = useNavigate();

  const [section, setSection] = useState<'workspaces' | 'add-to-workspace'>('workspaces');
  const [dialogOpen, setDialogOpen] = useState(false);
  // const [_, setRefresh] = useState(false);

  const numWorkspaces = Array.from(workspaces.entries()).length;
  let width = 'max-w-md';
  if (numWorkspaces > 20) width = 'max-w-3xl';
  if (numWorkspaces > 10) width = 'max-w-xl';

  // Check if `CSX:admin` is in the adminRoles array
  const isCsxAdmin = adminRoles.includes('CSX:admin');
  const isCsx = csxRole?.includes('CSX:');

  return (
    <main className="flex flex-col min-h-screen w-full p-0 bg-gray-100">
      <div className="flex-grow flex flex-col items-center justify-center">
        <h1 className="text-xl font-medium mb-8 text-center">
          Welcome back <strong>{profile?.firstName}</strong>!
        </h1>

        <div className={`flex flex-col gap-6 w-full ${width} justify-center items-center`}>
          {section === 'workspaces' && (
            <WorkspacesList workspaces={workspaces as Map<WorkspaceId, Workspace>} />
          )}

          {section === 'add-to-workspace' && (
            <AddWorkspaceCard workspaces={workspaces as Map<WorkspaceId, Workspace>} />
          )}

          <Dock
            disableOnCreateWorkspace={!isCsxAdmin || !isCsx}
            onAddToWorkspace={() => setSection('add-to-workspace')}
            onCreateWorkspace={() => setDialogOpen(true)}
            onHome={() => navigate('/w')}
            onViewWorkspaces={() => setSection('workspaces')}
          />

          <CreateWorkspaceDialog
            open={dialogOpen}
            setOpen={setDialogOpen}
          />
        </div>
      </div>
    </main>
  );
}

WorkspacesListPage.displayName = 'WorkspacesListPage';

const handle = {
  showNav: false,
  title: 'Workspaces',
};

export {
  WorkspacesListPage as Component,
  handle,
};
